import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import { EditProfile, Loader } from '../../components';
import { EditProfileMobile } from '../../components/EditProfileMobile';
import {
  updateAccount,
  changePassword,
} from '../../store/actions/Authentication';
import { addFlashMessage, clearMessage } from '../../store/actions/Flash';
import { routesAction } from '../../shared/helpers';
import { openDialog, closeDialog } from '../../store/actions/Dialog';
import { EditPasswordPopup } from '../../components/Popup/EditPasswordPopup';
import { isMobile } from "react-device-detect";
import api from '../../api';

class MyProfile extends Component {
  state = {
    usaStates: [],
  };

  componentDidMount() {
    this.getUSAStates();
  }

  handleEditProfile = () => {
    const {
      dispatchOpenDialog,
      dispatchCloseDialog,
      dispatchChangePassword,
    } = this.props;

    const popup = {
      id: 'edit-password-popup',
      body: (
        <EditPasswordPopup
          onSubmit={data => {
            dispatchChangePassword(data).then(() => {
              dispatchCloseDialog();
            });
          }}
        />
      ),
    };

    dispatchOpenDialog(popup);
  };

  // eslint-disable-next-line consistent-return
  getUSAStates = async () => {
    try {
      const { data } = await api.fetchUSAStates();
      if (!isEmpty(data)) {
        const usaStates = data.map(s => ({
          key: s.id,
          text: s.name,
          value: s.name,
        }));
        this.setState({ usaStates });
      }
    } catch (e) {
      return [];
    }
  };

  render() {
    const {
      isFetchingAccountUpdate,
      loaderMessage,
      dispatchAccountUpdate,
      user,
    } = this.props;

    const phoneNumberDDI = user.phone_number_ddi ? user.phone_number_ddi : '+1';

    if (isMobile) {
      return (
        <div>
          {isFetchingAccountUpdate && (
            <Loader overlay isActive message={loaderMessage} />
          )}
          <EditProfileMobile
            {...user}
            phone_number_ddi={phoneNumberDDI}
            handleEditProfile={this.handleEditProfile}
            usaStates={this.state.usaStates}
            onSubmit={(formData, setSubmitting) => {
              dispatchAccountUpdate(formData, setSubmitting)}
            }
          />
        </div>
      )
    }

    return (
      <div>
        {isFetchingAccountUpdate && (
          <Loader overlay isActive message={loaderMessage} />
        )}
        <EditProfile
          {...user}
          phone_number_ddi={phoneNumberDDI}
          handleEditProfile={this.handleEditProfile}
          usaStates={this.state.usaStates}
          onSubmit={(formData, setSubmitting) =>
            dispatchAccountUpdate(formData, setSubmitting)
          }
        />
      </div>
    );
  }
}

MyProfile.propTypes = {
  dispatchOpenDialog: PropTypes.func,
  dispatchCloseDialog: PropTypes.func,
  dispatchChangePassword: PropTypes.func,
  isFetchingAccountUpdate: PropTypes.any,
  loaderMessage: PropTypes.any,
  dispatchAccountUpdate: PropTypes.func,
  user: PropTypes.any,
};

const mapStateToProps = state => ({
  clientTabActive: state.authentication.clientActiveTab,
  isFetchingAccountUpdate: state.authentication.isFetchingAccountUpdate,
  user: state.authentication.user,
  loaderMessage: state.loader.message,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  dispatchAccountUpdate: (formData, setSubmitting) => {
    dispatch(updateAccount(formData)).then(action => {
      setSubmitting(false);
      if (action && action.type === 'UPDATE_ACCOUNT_SUCCESS') {
        ownProps.history.push(routesAction.default());
        dispatch(clearMessage());
        dispatch(
          addFlashMessage(['Your account has been updated!'], 'success'),
        );
      }
    });
  },
  dispatchOpenDialog: (content, options) => {
    dispatch(openDialog(content, options));
  },
  dispatchCloseDialog: () => {
    dispatch(closeDialog());
  },
  dispatchChangePassword: data => dispatch(changePassword(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MyProfile);



// WEBPACK FOOTER //
// ./src/containers/MyProfile/MyProfile.js